import { styled } from '@mui/material/styles';

const LogoRoot = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    width="1449.333";
    height="649.333";
`;

const LogoImage = styled('img')`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; 
    margin-right: 10px; 
`;

const CompanyName = styled('h1')`
    font-size: 36px; 
`;

const CompanyLogoRectangleWithTitle = (props) => {
  /*
      MDM Logo Horizontal with `Token MDM` title.
      Transformed from SVG to React Component using https://svg2jsx.com/
      --------------------------------
      Example usage:

        <MDMLogoHorizontalWithTitle
          sx={{
            height: 200
          }}
        />
    */

  const {logoUrl, companyName, color} = props;
    return (
        <LogoRoot
            width="1449.333"
            height="649.333"
            preserveAspectRatio="xMidYMid meet"
            version="1"
            viewBox="0 0 1087 487"
            {...props}

        >
            {logoUrl !== "" && (
                <LogoImage src={logoUrl} alt="Company Logo"></LogoImage>
            )}
            <CompanyName style={{color}}>{companyName}</CompanyName>
        </LogoRoot>
    );
}

export default CompanyLogoRectangleWithTitle;
